// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/auth3main.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  max-height: 100vh;
  position: relative;
  overflow: hidden;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}
.login-container::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(30, 30, 60, 0.8) 100%);
  z-index: 1;
}
.login-container .bubble {
  position: absolute;
  bottom: -100px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  opacity: 0.6;
  animation: rise 15s infinite ease-in;
  z-index: 2;
  backdrop-filter: blur(2px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.login-container .bubble:nth-child(1) {
  width: 80px;
  height: 80px;
  left: 10%;
  animation-duration: 12s;
  animation-delay: 0s;
}
.login-container .bubble:nth-child(2) {
  width: 60px;
  height: 60px;
  left: 20%;
  animation-duration: 14s;
  animation-delay: 2s;
}
.login-container .bubble:nth-child(3) {
  width: 100px;
  height: 100px;
  left: 35%;
  animation-duration: 16s;
  animation-delay: 4s;
}
.login-container .bubble:nth-child(4) {
  width: 70px;
  height: 70px;
  left: 50%;
  animation-duration: 13s;
  animation-delay: 1s;
}
.login-container .bubble:nth-child(5) {
  width: 90px;
  height: 90px;
  left: 65%;
  animation-duration: 15s;
  animation-delay: 3s;
}
.login-container .bubble:nth-child(6) {
  width: 55px;
  height: 55px;
  left: 80%;
  animation-duration: 11s;
  animation-delay: 5s;
}
.login-container .bubble:nth-child(7) {
  width: 75px;
  height: 75px;
  left: 15%;
  animation-duration: 17s;
  animation-delay: 6s;
}
.login-container .bubble:nth-child(8) {
  width: 65px;
  height: 65px;
  left: 90%;
  animation-duration: 14s;
  animation-delay: 2.5s;
}
.login-container .bubble:nth-child(9) {
  width: 85px;
  height: 85px;
  left: 5%;
  animation-duration: 18s;
  animation-delay: 7s;
}
.login-container .bubble:nth-child(10) {
  width: 95px;
  height: 95px;
  left: 75%;
  animation-duration: 13.5s;
  animation-delay: 4.5s;
}
@keyframes rise {
  0% {
    bottom: -100px;
    transform: translateX(0) scale(0.8);
    opacity: 0;
  }
  10% {
    opacity: 0.6;
  }
  90% {
    opacity: 0.6;
  }
  100% {
    bottom: 110vh;
    transform: translateX(100px) scale(1.2);
    opacity: 0;
  }
}
.login-container .super-admin-badge {
  position: absolute;
  top: 40px;
  left: 40px;
  z-index: 10;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.15) 100%);
  backdrop-filter: blur(20px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50px;
  padding: 14px 32px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  animation: glow 3s ease-in-out infinite;
}
@keyframes glow {
  0%, 100% {
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3), 0 0 20px rgba(59, 91, 219, 0.3);
  }
  50% {
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3), 0 0 30px rgba(59, 91, 219, 0.6);
  }
}
.login-container .super-admin-badge .badge-icon {
  font-size: 2rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}
.login-container .super-admin-badge .badge-text {
  color: white;
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
}
.login-container .image-section {
  display: none;
}
.login-container .form-section {
  width: 100%;
  max-width: 580px;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  display: flex;
  position: relative;
  padding: 0;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-radius: 28px;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.4);
  z-index: 10;
  max-height: 92vh;
  overflow-y: auto;
  animation: fadeInUp 0.6s ease-out;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.login-container .form-section::-webkit-scrollbar {
  width: 6px;
}
.login-container .form-section::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 10px;
}
.login-container .form-section::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
.login-container .form-section::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}
.login-container .form-section .main-logo-log {
  width: 100%;
  display: flex;
  padding: 40px 50px 15px;
  justify-content: center;
  flex-shrink: 0;
}
.login-container .form-section .main-logo-log .logo-dark-main-login {
  height: 9vh;
  min-height: 50px;
  max-height: 60px;
  cursor: pointer;
  transition: transform 0.3s ease;
}
.login-container .form-section .main-logo-log .logo-dark-main-login:hover {
  transform: scale(1.08);
}
.login-container .form-section .auth-form-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 50px 50px;
  width: 100%;
  overflow-y: auto;
}
.login-container .form-section .forgot-password {
  margin-bottom: 28px;
  font-size: 15px;
  text-align: center;
}
.login-container .form-section .forgot-password .forgot-password-text {
  color: #6b7280;
}
.login-container .form-section .forgot-password .forgot-password-link {
  color: #3b5bdb;
  margin-inline-start: 5px;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s ease;
}
.login-container .form-section .forgot-password .forgot-password-link:hover {
  text-decoration: underline;
  color: #2845c7;
}
.login-container .form-section .form-title {
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  text-align: center;
  margin-bottom: 12px;
  width: 100%;
  line-height: 1.3;
}
.login-container .form-section .form-subtitle {
  display: none;
}
.login-container .form-section .mode-tabs {
  display: flex;
  width: 100%;
  margin-bottom: 36px;
  border-bottom: 2px solid #e5e7eb;
  overflow: hidden;
  border-radius: 8px 8px 0 0;
}
.login-container .form-section .mode-tabs .mode-tab {
  flex: 1 1;
  padding: 18px 0;
  border: none;
  background: none;
  color: #6b7280;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  white-space: nowrap;
}
.login-container .form-section .mode-tabs .mode-tab:hover {
  color: #374151;
  background: rgba(59, 91, 219, 0.05);
}
.login-container .form-section .mode-tabs .mode-tab.active {
  color: #3b5bdb;
}
.login-container .form-section .mode-tabs .mode-tab.active::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 3px;
  background: #3b5bdb;
  border-radius: 3px 3px 0 0;
}
.login-container .form-section .auth-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 28px;
}
.login-container .form-section .auth-form .input-section .input-label {
  display: block;
  margin-bottom: 10px;
}
.login-container .form-section .auth-form .input-section .input-label .label-text {
  display: inline-flex;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: #374151;
  padding: 0;
}
.login-container .form-section .auth-form .input-section .input-container {
  display: flex;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  background: white;
  position: relative;
  min-height: 58px;
  transition: all 0.3s ease;
}
.login-container .form-section .auth-form .input-section .input-container:focus-within {
  border-color: #3b5bdb;
  box-shadow: 0 0 0 3px rgba(59, 91, 219, 0.1);
}
.login-container .form-section .auth-form .input-section .input-container .country-code {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 18px;
  background: #f9fafb;
  border-right: 2px solid #e5e7eb;
  gap: 8px;
  font-size: 15px;
  color: #374151;
  font-weight: 600;
  min-width: 90px;
  text-align: center;
  white-space: nowrap;
}
.login-container .form-section .auth-form .input-section .input-container .country-code .flag {
  font-size: 18px;
  line-height: 1;
}
.login-container .form-section .auth-form .input-section .input-container .input-field {
  flex: 1 1;
  border: none;
  padding: 16px 18px;
  font-size: 16px;
  color: #1f2937;
  background: transparent;
  min-width: 0;
  font-weight: 500;
}
.login-container .form-section .auth-form .input-section .input-container .input-field:focus {
  outline: none;
}
.login-container .form-section .auth-form .input-section .input-container .input-field::placeholder {
  color: #9ca3af;
  font-weight: 400;
}
.login-container .form-section .auth-form .input-section .input-container .resend-otp-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: #3b5bdb;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.login-container .form-section .auth-form .input-section .input-container .resend-otp-btn:hover:not(:disabled) {
  background: #2845c7;
  transform: translateY(-50%) scale(1.05);
}
.login-container .form-section .auth-form .input-section .input-container .resend-otp-btn:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
}
.login-container .form-section .auth-form .otp-input-section {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.login-container .form-section .auth-form .otp-input-section .input-label {
  display: block;
  margin-bottom: 0;
}
.login-container .form-section .auth-form .otp-input-section .input-label .label-text {
  display: inline-flex;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: #374151;
  padding: 0;
}
.login-container .form-section .auth-form .otp-input-section .otp-boxes {
  display: flex;
  gap: 12px;
  justify-content: space-between;
}
.login-container .form-section .auth-form .otp-input-section .otp-boxes .otp-input {
  width: 56px;
  height: 62px;
  border: 2px solid #e5e7eb;
  border-radius: 14px;
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  color: #1f2937;
  flex: 1 1;
  max-width: 70px;
  transition: all 0.3s ease;
  background: white;
}
.login-container .form-section .auth-form .otp-input-section .otp-boxes .otp-input:focus {
  outline: none;
  border-color: #3b5bdb;
  box-shadow: 0 0 0 3px rgba(59, 91, 219, 0.1);
  transform: scale(1.05);
}
.login-container .form-section .auth-form .otp-input-section .otp-boxes .otp-input:not(:placeholder-shown) {
  border-color: #3b5bdb;
  background: rgba(59, 91, 219, 0.05);
}
.login-container .form-section .auth-form .error-message {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  color: #dc2626;
  padding: 16px 20px;
  border-radius: 12px;
  font-size: 15px;
  border: 2px solid #fecaca;
  text-align: center;
  font-weight: 600;
  animation: shake 0.5s ease-out;
}
@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-10px);
  }
  75% {
    transform: translateX(10px);
  }
}
.login-container .form-section .auth-form .send-otp-btn {
  width: 100%;
  background: linear-gradient(135deg, #3b5bdb 0%, #2845c7 100%);
  color: white;
  border: none;
  padding: 18px;
  border-radius: 14px;
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 60px;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.login-container .form-section .auth-form .send-otp-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 91, 219, 0.4);
}
.login-container .form-section .auth-form .send-otp-btn:active:not(:disabled) {
  transform: translateY(0);
}
.login-container .form-section .auth-form .send-otp-btn:disabled {
  background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);
  cursor: not-allowed;
  box-shadow: none;
}
.login-container .form-section .auth-form .auth-divider {
  display: flex;
  align-items: center;
  color: #9ca3af;
  font-size: 14px;
  margin: 8px 0;
}
.login-container .form-section .auth-form .auth-divider::before, .login-container .form-section .auth-form .auth-divider::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: #e5e7eb;
}
.login-container .form-section .auth-form .auth-divider span {
  padding: 0 16px;
}
.login-container .form-section .auth-form .social-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 100%;
}
.login-container .form-section .auth-form .social-buttons .social-btn {
  flex: 1 1;
  height: 52px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
}
.login-container .form-section .auth-form .social-buttons .social-btn:hover {
  background-color: #f9fafb;
  border-color: #d1d5db;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.login-container .form-section .auth-form .social-buttons .social-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}
.login-container .form-section .auth-form .social-buttons .social-btn:hover::before {
  left: 100%;
}
.login-container .form-section .auth-form .social-buttons .social-btn img {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
}
.login-container .form-section .auth-form .social-buttons .social-btn:hover img {
  transform: scale(1.1) rotate(5deg);
}
.login-container .access-denied-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}
.login-container .access-denied-overlay .access-denied-modal {
  background: white;
  border-radius: 24px;
  padding: 48px 40px;
  max-width: 480px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(0, 0, 0, 0.05);
  position: relative;
}
.login-container .access-denied-overlay .access-denied-modal .access-denied-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}
.login-container .access-denied-overlay .access-denied-modal .access-denied-icon svg {
  animation: modalIconPulse 2s ease-in-out infinite;
}
@keyframes modalIconPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.9;
  }
}
.login-container .access-denied-overlay .access-denied-modal h2 {
  font-size: 32px;
  font-weight: 800;
  color: #1f2937;
  margin-bottom: 16px;
  letter-spacing: -0.5px;
}
.login-container .access-denied-overlay .access-denied-modal .main-message {
  font-size: 16px;
  color: #4b5563;
  font-weight: 500;
  margin-bottom: 20px;
  line-height: 1.6;
}
.login-container .access-denied-overlay .access-denied-modal .contact-info {
  display: flex;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  color: #6b7280;
  background: #f9fafb;
  padding: 14px 18px;
  border-radius: 12px;
  margin-bottom: 28px;
  font-weight: 500;
}
.login-container .access-denied-overlay .access-denied-modal .contact-info svg {
  flex-shrink: 0;
  color: #9ca3af;
}
.login-container .access-denied-overlay .access-denied-modal .close-modal-btn {
  width: 100%;
  background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
  color: white;
  border: none;
  padding: 16px 28px;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: 0.5px;
}
.login-container .access-denied-overlay .access-denied-modal .close-modal-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(220, 38, 38, 0.4);
}
.login-container .access-denied-overlay .access-denied-modal .close-modal-btn:active {
  transform: translateY(0);
}
@media (max-width: 1024px) {
  .login-container .super-admin-badge {
    padding: 5px 12px;
    top: 30px;
    left: 30px;
  }
  .login-container .super-admin-badge .badge-icon {
    font-size: 1.8rem;
  }
  .login-container .super-admin-badge .badge-text {
    font-size: 0.9rem;
    letter-spacing: 1.5px;
  }
  .login-container .form-section {
    max-width: 520px;
    border-radius: 24px;
  }
  .login-container .form-section .auth-form-content {
    padding: 18px 40px 40px;
  }
  .login-container .form-section .form-title {
    font-size: 28px;
  }
}
@media (max-width: 1024px) and (max-height: 600px) {
  .login-container .super-admin-badge {
    padding: 10px 24px;
    top: 20px;
    left: 20px;
  }
  .login-container .super-admin-badge .badge-icon {
    font-size: 1.5rem;
  }
  .login-container .super-admin-badge .badge-text {
    font-size: 0.8rem;
    letter-spacing: 1px;
  }
  .login-container .form-section {
    max-width: 400px;
    max-height: 85vh;
    border-radius: 16px;
  }
  .login-container .form-section .main-logo-log {
    padding: 20px 30px 10px;
  }
  .login-container .form-section .main-logo-log .logo-dark-main-login {
    height: 5vh;
    min-height: 25px;
    max-height: 40px;
  }
  .login-container .form-section .auth-form-content {
    padding: 8px 30px 20px;
  }
  .login-container .form-section .form-title {
    font-size: 20px;
    margin-bottom: 8px;
  }
  .login-container .form-section .forgot-password {
    margin-bottom: 16px;
    font-size: 12px;
  }
  .login-container .form-section .mode-tabs {
    margin-bottom: 20px;
  }
  .login-container .form-section .mode-tabs .mode-tab {
    padding: 10px 0;
    font-size: 12px;
  }
  .login-container .form-section .auth-form {
    gap: 16px;
  }
  .login-container .form-section .auth-form .input-section .input-container {
    min-height: 46px;
  }
  .login-container .form-section .auth-form .input-section .input-container .country-code {
    padding: 8px 12px;
    font-size: 12px;
  }
  .login-container .form-section .auth-form .input-section .input-container .input-field {
    padding: 10px 12px;
    font-size: 14px;
  }
  .login-container .form-section .auth-form .input-section .input-container .resend-otp-btn {
    font-size: 11px;
    padding: 6px 10px;
  }
  .login-container .form-section .auth-form .otp-input-section .otp-boxes .otp-input {
    width: 40px;
    height: 46px;
    font-size: 16px;
    max-width: 50px;
  }
  .login-container .form-section .auth-form .send-otp-btn {
    padding: 12px;
    font-size: 14px;
    min-height: 46px;
  }
}
@media (max-width: 850px) {
  .login-container .super-admin-badge {
    padding: 10px 24px;
    top: 25px;
    left: 25px;
  }
  .login-container .super-admin-badge .badge-icon {
    font-size: 1.6rem;
  }
  .login-container .super-admin-badge .badge-text {
    font-size: 0.85rem;
    letter-spacing: 1px;
  }
  .login-container .form-section {
    max-width: 420px;
    margin: 20px;
    border-radius: 20px;
  }
  .login-container .form-section .main-logo-log {
    padding: 24px 30px 12px;
  }
  .login-container .form-section .main-logo-log .logo-dark-main-login {
    height: 6vh;
    min-height: 35px;
    max-height: 50px;
  }
  .login-container .form-section .auth-form-content {
    padding: 12px 30px 30px;
  }
  .login-container .form-section .form-title {
    font-size: 22px;
    margin-bottom: 12px;
  }
  .login-container .form-section .mode-tabs {
    margin-bottom: 24px;
  }
  .login-container .form-section .mode-tabs .mode-tab {
    padding: 14px 0;
    font-size: 13px;
  }
  .login-container .form-section .auth-form {
    gap: 20px;
  }
  .login-container .form-section .auth-form .input-section .input-container .resend-otp-btn {
    font-size: 12px;
    padding: 8px 12px;
  }
  .login-container .form-section .auth-form .otp-input-section .otp-boxes {
    gap: 8px;
  }
  .login-container .form-section .auth-form .otp-input-section .otp-boxes .otp-input {
    width: auto;
    min-width: 42px;
    max-width: none;
    flex: 1 1;
    height: 50px;
    font-size: 18px;
  }
  .login-container .form-section .auth-form .social-buttons {
    flex-direction: column;
    gap: 12px;
  }
  .login-container .form-section .auth-form .social-buttons .social-btn {
    height: 50px;
  }
}
@media (max-width: 480px) {
  .login-container .super-admin-badge {
    padding: 8px 20px;
    top: 20px;
    left: 20px;
  }
  .login-container .super-admin-badge .badge-icon {
    font-size: 1.4rem;
  }
  .login-container .super-admin-badge .badge-text {
    font-size: 0.75rem;
    letter-spacing: 0.8px;
  }
  .login-container .bubble:nth-child(n+7) {
    display: none;
  }
  .login-container .form-section {
    max-width: 90%;
    margin: 15px;
    border-radius: 18px;
  }
  .login-container .form-section .main-logo-log {
    padding: 20px 20px 10px;
  }
  .login-container .form-section .main-logo-log .logo-dark-main-login {
    height: 5vh;
    min-height: 32px;
    max-height: 45px;
  }
  .login-container .form-section .auth-form-content {
    padding: 10px 20px 25px;
  }
  .login-container .form-section .form-title {
    font-size: 20px;
    margin-bottom: 8px;
  }
  .login-container .form-section .forgot-password {
    margin-bottom: 16px;
    font-size: 13px;
  }
  .login-container .form-section .mode-tabs {
    margin-bottom: 20px;
  }
  .login-container .form-section .mode-tabs .mode-tab {
    padding: 12px 0;
    font-size: 12px;
  }
  .login-container .form-section .auth-form {
    gap: 18px;
  }
  .login-container .form-section .auth-form .input-section .input-container {
    min-height: 50px;
  }
  .login-container .form-section .auth-form .input-section .input-container .country-code {
    padding: 10px 12px;
    min-width: 75px;
    font-size: 13px;
  }
  .login-container .form-section .auth-form .input-section .input-container .input-field {
    padding: 12px 14px;
    font-size: 16px;
  }
  .login-container .form-section .auth-form .input-section .input-container .resend-otp-btn {
    font-size: 11px;
    padding: 7px 11px;
  }
  .login-container .form-section .auth-form .otp-input-section .otp-boxes {
    gap: 6px;
  }
  .login-container .form-section .auth-form .otp-input-section .otp-boxes .otp-input {
    height: 48px;
    font-size: 17px;
    min-width: 38px;
  }
  .login-container .form-section .auth-form .send-otp-btn {
    padding: 14px;
    font-size: 15px;
    min-height: 50px;
  }
}
@media (max-width: 320px) {
  .login-container .super-admin-badge {
    padding: 6px 16px;
    top: 15px;
    left: 15px;
  }
  .login-container .super-admin-badge .badge-icon {
    font-size: 1.2rem;
  }
  .login-container .super-admin-badge .badge-text {
    font-size: 0.7rem;
    letter-spacing: 0.5px;
  }
  .login-container .form-section {
    max-width: 95%;
    margin: 10px;
    border-radius: 16px;
  }
  .login-container .form-section .main-logo-log {
    padding: 16px 15px 8px;
  }
  .login-container .form-section .main-logo-log .logo-dark-main-login {
    height: 4vh;
    min-height: 28px;
    max-height: 38px;
  }
  .login-container .form-section .auth-form-content {
    padding: 8px 15px 20px;
  }
  .login-container .form-section .form-title {
    font-size: 18px;
    margin-bottom: 6px;
  }
  .login-container .form-section .auth-form {
    gap: 14px;
  }
  .login-container .form-section .auth-form .input-section .input-container .country-code {
    padding: 8px 10px;
    min-width: 68px;
    font-size: 12px;
  }
  .login-container .form-section .auth-form .input-section .input-container .input-field {
    padding: 10px 12px;
  }
  .login-container .form-section .auth-form .input-section .input-container .resend-otp-btn {
    font-size: 10px;
    padding: 6px 9px;
  }
  .login-container .form-section .auth-form .otp-input-section .otp-boxes {
    gap: 4px;
  }
  .login-container .form-section .auth-form .otp-input-section .otp-boxes .otp-input {
    min-width: 34px;
    height: 46px;
    font-size: 16px;
  }
}
@media (min-resolution: 192dpi) {
  .login-container .form-section .main-logo-log .logo-dark-main-login {
    image-rendering: -webkit-optimize-contrast;
  }
}
@media (prefers-reduced-motion: reduce) {
  .login-container *,
  .login-container *::before,
  .login-container *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
  .login-container .bubble {
    animation: none !important;
  }
}
@media print {
  .login-container .super-admin-badge,
  .login-container .bubble {
    display: none;
  }
  .login-container .form-section {
    box-shadow: none;
    background: white;
  }
}`, "",{"version":3,"sources":["webpack://./src/auth/auth.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AACF;AAEE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,sFAAA;EACA,UAAA;AAAJ;AAIE;EACE,kBAAA;EACA,cAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,UAAA;EACA,0BAAA;EACA,0CAAA;AAFJ;AAII;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AAFN;AAKI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AAHN;AAMI;EACE,YAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AAJN;AAOI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AALN;AAQI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AANN;AASI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AAPN;AAUI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AARN;AAWI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,qBAAA;AATN;AAYI;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;AAVN;AAaI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,yBAAA;EACA,qBAAA;AAXN;AAeE;EACE;IACE,cAAA;IACA,mCAAA;IACA,UAAA;EAbJ;EAeE;IACE,YAAA;EAbJ;EAeE;IACE,YAAA;EAbJ;EAeE;IACE,aAAA;IACA,uCAAA;IACA,UAAA;EAbJ;AACF;AAiBE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,iGAAA;EACA,2BAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yCAAA;EACA,uCAAA;AAfJ;AAiBI;EACE;IACE,0EAAA;EAfN;EAiBI;IACE,0EAAA;EAfN;AACF;AAkBI;EACE,eAAA;EACA,iDAAA;AAhBN;AAmBI;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,2CAAA;AAjBN;AAsBE;EACE,aAAA;AApBJ;AAwBE;EACE,WAAA;EACA,gBAAA;EACA,qCAAA;EACA,2BAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,0CAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iCAAA;AAtBJ;AAwBI;EACE;IACE,UAAA;IACA,2BAAA;EAtBN;EAwBI;IACE,UAAA;IACA,wBAAA;EAtBN;AACF;AA0BI;EACE,UAAA;AAxBN;AA2BI;EACE,+BAAA;EACA,mBAAA;AAzBN;AA4BI;EACE,8BAAA;EACA,mBAAA;AA1BN;AA4BM;EACE,8BAAA;AA1BR;AA8BI;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,cAAA;AA5BN;AA8BM;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AA5BR;AA8BQ;EACE,sBAAA;AA5BV;AAiCI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AA/BN;AAkCI;EACE,mBAAA;EACA,eAAA;EACA,kBAAA;AAhCN;AAkCM;EACE,cAAA;AAhCR;AAmCM;EACE,cAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,2BAAA;AAjCR;AAmCQ;EACE,0BAAA;EACA,cAAA;AAjCV;AAsCI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AApCN;AAuCI;EACE,aAAA;AArCN;AAwCI;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,0BAAA;AAtCN;AAwCM;EACE,SAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAtCR;AAwCQ;EACE,cAAA;EACA,mCAAA;AAtCV;AAyCQ;EACE,cAAA;AAvCV;AAyCU;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;EACA,0BAAA;AAvCZ;AA6CI;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA3CN;AA8CQ;EACE,cAAA;EACA,mBAAA;AA5CV;AA8CU;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AA5CZ;AAgDQ;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AA9CV;AAgDU;EACE,qBAAA;EACA,4CAAA;AA9CZ;AAiDU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AA/CZ;AAiDY;EACE,eAAA;EACA,cAAA;AA/Cd;AAmDU;EACE,SAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AAjDZ;AAmDY;EACE,aAAA;AAjDd;AAoDY;EACE,cAAA;EACA,gBAAA;AAlDd;AAsDU;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;AApDZ;AAsDY;EACE,mBAAA;EACA,uCAAA;AApDd;AAuDY;EACE,mBAAA;EACA,mBAAA;AArDd;AA2DM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAzDR;AA2DQ;EACE,cAAA;EACA,gBAAA;AAzDV;AA2DU;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AAzDZ;AA6DQ;EACE,aAAA;EACA,SAAA;EACA,8BAAA;AA3DV;AA6DU;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;AA3DZ;AA6DY;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;EACA,sBAAA;AA3Dd;AA8DY;EACE,qBAAA;EACA,mCAAA;AA5Dd;AAkEM;EACE,6DAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;AAhER;AAmEM;EACE;IACE,wBAAA;EAjER;EAmEM;IACE,4BAAA;EAjER;EAmEM;IACE,2BAAA;EAjER;AACF;AAoEM;EACE,WAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAlER;AAoEQ;EACE,2BAAA;EACA,6CAAA;AAlEV;AAqEQ;EACE,wBAAA;AAnEV;AAsEQ;EACE,6DAAA;EACA,mBAAA;EACA,gBAAA;AApEV;AAwEM;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;AAtER;AAwEQ;EAEE,WAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AAvEV;AA0EQ;EACE,eAAA;AAxEV;AA4EM;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AA1ER;AA4EQ;EACE,SAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA1EV;AA4EU;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;EACA,yCAAA;AA1EZ;AA6EU;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,0BAAA;AA3EZ;AA8EU;EACE,UAAA;AA5EZ;AA+EU;EACE,WAAA;EACA,YAAA;EACA,+BAAA;AA7EZ;AAgFU;EACE,kCAAA;AA9EZ;AAqFG;EACC,eAAA;EACA,QAAA;EACA,8BAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AAnFJ;AAqFI;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,yEAAA;EACA,kBAAA;AAnFN;AAqFM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAnFR;AAqFQ;EACE,iDAAA;AAnFV;AAsFQ;EACE;IACE,mBAAA;IACA,UAAA;EApFV;EAsFQ;IACE,sBAAA;IACA,YAAA;EApFV;AACF;AAwFM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AAtFR;AAyFM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAvFR;AA0FM;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAxFR;AA0FQ;EACE,cAAA;EACA,cAAA;AAxFV;AA4FM;EACE,WAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iDAAA;EACA,qBAAA;AA1FR;AA4FQ;EACE,2BAAA;EACA,6CAAA;AA1FV;AA6FQ;EACE,wBAAA;AA3FV;AAmGE;EACE;IACE,iBAAA;IACA,SAAA;IACA,UAAA;EAjGJ;EAmGI;IACE,iBAAA;EAjGN;EAoGI;IACE,iBAAA;IACA,qBAAA;EAlGN;EAsGE;IACE,gBAAA;IACA,mBAAA;EApGJ;EAsGI;IACE,uBAAA;EApGN;EAuGI;IACE,eAAA;EArGN;AACF;AA0GE;EACE;IACE,kBAAA;IACA,SAAA;IACA,UAAA;EAxGJ;EA0GI;IACE,iBAAA;EAxGN;EA2GI;IACE,iBAAA;IACA,mBAAA;EAzGN;EA6GE;IACE,gBAAA;IACA,gBAAA;IACA,mBAAA;EA3GJ;EA6GI;IACE,uBAAA;EA3GN;EA6GM;IACE,WAAA;IACA,gBAAA;IACA,gBAAA;EA3GR;EA+GI;IACE,sBAAA;EA7GN;EAgHI;IACE,eAAA;IACA,kBAAA;EA9GN;EAiHI;IACE,mBAAA;IACA,eAAA;EA/GN;EAkHI;IACE,mBAAA;EAhHN;EAkHM;IACE,eAAA;IACA,eAAA;EAhHR;EAoHI;IACE,SAAA;EAlHN;EAqHQ;IACE,gBAAA;EAnHV;EAqHU;IACE,iBAAA;IACA,eAAA;EAnHZ;EAsHU;IACE,kBAAA;IACA,eAAA;EApHZ;EAuHU;IACE,eAAA;IACA,iBAAA;EArHZ;EA4HU;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,eAAA;EA1HZ;EA+HM;IACE,aAAA;IACA,eAAA;IACA,gBAAA;EA7HR;AACF;AAmIE;EACE;IACE,kBAAA;IACA,SAAA;IACA,UAAA;EAjIJ;EAmII;IACE,iBAAA;EAjIN;EAoII;IACE,kBAAA;IACA,mBAAA;EAlIN;EAsIE;IACE,gBAAA;IACA,YAAA;IACA,mBAAA;EApIJ;EAsII;IACE,uBAAA;EApIN;EAsIM;IACE,WAAA;IACA,gBAAA;IACA,gBAAA;EApIR;EAwII;IACE,uBAAA;EAtIN;EAyII;IACE,eAAA;IACA,mBAAA;EAvIN;EA0II;IACE,mBAAA;EAxIN;EA0IM;IACE,eAAA;IACA,eAAA;EAxIR;EA4II;IACE,SAAA;EA1IN;EA8IU;IACE,eAAA;IACA,iBAAA;EA5IZ;EAkJQ;IACE,QAAA;EAhJV;EAkJU;IACE,WAAA;IACA,eAAA;IACA,eAAA;IACA,SAAA;IACA,YAAA;IACA,eAAA;EAhJZ;EAqJM;IACE,sBAAA;IACA,SAAA;EAnJR;EAqJQ;IACE,YAAA;EAnJV;AACF;AA0JE;EACE;IACE,iBAAA;IACA,SAAA;IACA,UAAA;EAxJJ;EA0JI;IACE,iBAAA;EAxJN;EA2JI;IACE,kBAAA;IACA,qBAAA;EAzJN;EA8JI;IACE,aAAA;EA5JN;EAgKE;IACE,cAAA;IACA,YAAA;IACA,mBAAA;EA9JJ;EAgKI;IACE,uBAAA;EA9JN;EAgKM;IACE,WAAA;IACA,gBAAA;IACA,gBAAA;EA9JR;EAkKI;IACE,uBAAA;EAhKN;EAmKI;IACE,eAAA;IACA,kBAAA;EAjKN;EAoKI;IACE,mBAAA;IACA,eAAA;EAlKN;EAqKI;IACE,mBAAA;EAnKN;EAqKM;IACE,eAAA;IACA,eAAA;EAnKR;EAuKI;IACE,SAAA;EArKN;EAwKQ;IACE,gBAAA;EAtKV;EAwKU;IACE,kBAAA;IACA,eAAA;IACA,eAAA;EAtKZ;EAyKU;IACE,kBAAA;IACA,eAAA;EAvKZ;EA0KU;IACE,eAAA;IACA,iBAAA;EAxKZ;EA8KQ;IACE,QAAA;EA5KV;EA8KU;IACE,YAAA;IACA,eAAA;IACA,eAAA;EA5KZ;EAiLM;IACE,aAAA;IACA,eAAA;IACA,gBAAA;EA/KR;AACF;AAqLE;EACE;IACE,iBAAA;IACA,SAAA;IACA,UAAA;EAnLJ;EAqLI;IACE,iBAAA;EAnLN;EAsLI;IACE,iBAAA;IACA,qBAAA;EApLN;EAwLE;IACE,cAAA;IACA,YAAA;IACA,mBAAA;EAtLJ;EAwLI;IACE,sBAAA;EAtLN;EAwLM;IACE,WAAA;IACA,gBAAA;IACA,gBAAA;EAtLR;EA0LI;IACE,sBAAA;EAxLN;EA2LI;IACE,eAAA;IACA,kBAAA;EAzLN;EA4LI;IACE,SAAA;EA1LN;EA8LU;IACE,iBAAA;IACA,eAAA;IACA,eAAA;EA5LZ;EA+LU;IACE,kBAAA;EA7LZ;EAgMU;IACE,eAAA;IACA,gBAAA;EA9LZ;EAoMQ;IACE,QAAA;EAlMV;EAoMU;IACE,eAAA;IACA,YAAA;IACA,eAAA;EAlMZ;AACF;AA0ME;EAIM;IACE,0CAAA;EA3MR;AACF;AAsNE;EACE;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;EApNJ;EAuNE;IACE,0BAAA;EArNJ;AACF;AAyNE;EACE;;IAEE,aAAA;EAvNJ;EA0NE;IACE,gBAAA;IACA,iBAAA;EAxNJ;AACF","sourcesContent":[".login-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  max-height: 100vh;\n  position: relative;\n  overflow: hidden;\n  background-image: url(\"../assets/images/auth3main.jpg\");\n  background-size: cover;\n  background-position: center;\n  background-attachment: fixed;\n\n  // Full screen overlay\n  &::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(30, 30, 60, 0.8) 100%);\n    z-index: 1;\n  }\n\n  // Animated bubbles\n  .bubble {\n    position: absolute;\n    bottom: -100px;\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 50%;\n    opacity: 0.6;\n    animation: rise 15s infinite ease-in;\n    z-index: 2;\n    backdrop-filter: blur(2px);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n\n    &:nth-child(1) {\n      width: 80px;\n      height: 80px;\n      left: 10%;\n      animation-duration: 12s;\n      animation-delay: 0s;\n    }\n\n    &:nth-child(2) {\n      width: 60px;\n      height: 60px;\n      left: 20%;\n      animation-duration: 14s;\n      animation-delay: 2s;\n    }\n\n    &:nth-child(3) {\n      width: 100px;\n      height: 100px;\n      left: 35%;\n      animation-duration: 16s;\n      animation-delay: 4s;\n    }\n\n    &:nth-child(4) {\n      width: 70px;\n      height: 70px;\n      left: 50%;\n      animation-duration: 13s;\n      animation-delay: 1s;\n    }\n\n    &:nth-child(5) {\n      width: 90px;\n      height: 90px;\n      left: 65%;\n      animation-duration: 15s;\n      animation-delay: 3s;\n    }\n\n    &:nth-child(6) {\n      width: 55px;\n      height: 55px;\n      left: 80%;\n      animation-duration: 11s;\n      animation-delay: 5s;\n    }\n\n    &:nth-child(7) {\n      width: 75px;\n      height: 75px;\n      left: 15%;\n      animation-duration: 17s;\n      animation-delay: 6s;\n    }\n\n    &:nth-child(8) {\n      width: 65px;\n      height: 65px;\n      left: 90%;\n      animation-duration: 14s;\n      animation-delay: 2.5s;\n    }\n\n    &:nth-child(9) {\n      width: 85px;\n      height: 85px;\n      left: 5%;\n      animation-duration: 18s;\n      animation-delay: 7s;\n    }\n\n    &:nth-child(10) {\n      width: 95px;\n      height: 95px;\n      left: 75%;\n      animation-duration: 13.5s;\n      animation-delay: 4.5s;\n    }\n  }\n\n  @keyframes rise {\n    0% {\n      bottom: -100px;\n      transform: translateX(0) scale(0.8);\n      opacity: 0;\n    }\n    10% {\n      opacity: 0.6;\n    }\n    90% {\n      opacity: 0.6;\n    }\n    100% {\n      bottom: 110vh;\n      transform: translateX(100px) scale(1.2);\n      opacity: 0;\n    }\n  }\n\n  // Super Admin Portal Badge - Oval Style\n  .super-admin-badge {\n    position: absolute;\n    top: 40px;\n    left: 40px;\n    z-index: 10;\n    background: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.15) 100%);\n    backdrop-filter: blur(20px);\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-radius: 50px;\n    padding: 14px 32px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n    animation: glow 3s ease-in-out infinite;\n\n    @keyframes glow {\n      0%, 100% {\n        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3), 0 0 20px rgba(59, 91, 219, 0.3);\n      }\n      50% {\n        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3), 0 0 30px rgba(59, 91, 219, 0.6);\n      }\n    }\n\n    .badge-icon {\n      font-size: 2rem;\n      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));\n    }\n\n    .badge-text {\n      color: white;\n      font-size: 1rem;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 2px;\n      text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);\n    }\n  }\n\n  // Image section - now hidden as background is full screen\n  .image-section {\n    display: none;\n  }\n\n  // Form section - centered with more space\n  .form-section {\n    width: 100%;\n    max-width: 580px;\n    background: rgba(255, 255, 255, 0.98);\n    backdrop-filter: blur(10px);\n    display: flex;\n    position: relative;\n    padding: 0;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    border-radius: 28px;\n    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.4);\n    z-index: 10;\n    max-height: 92vh;\n    overflow-y: auto;\n    animation: fadeInUp 0.6s ease-out;\n\n    @keyframes fadeInUp {\n      from {\n        opacity: 0;\n        transform: translateY(30px);\n      }\n      to {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n\n    // Custom scrollbar\n    &::-webkit-scrollbar {\n      width: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: rgba(0, 0, 0, 0.05);\n      border-radius: 10px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: rgba(0, 0, 0, 0.2);\n      border-radius: 10px;\n\n      &:hover {\n        background: rgba(0, 0, 0, 0.3);\n      }\n    }\n\n    .main-logo-log {\n      width: 100%;\n      display: flex;\n      padding: 40px 50px 15px;\n      justify-content: center;\n      flex-shrink: 0;\n\n      .logo-dark-main-login {\n        height: 9vh;\n        min-height: 50px;\n        max-height: 60px;\n        cursor: pointer;\n        transition: transform 0.3s ease;\n\n        &:hover {\n          transform: scale(1.08);\n        }\n      }\n    }\n\n    .auth-form-content {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      padding: 0px 50px 50px;\n      width: 100%;\n      overflow-y: auto;\n    }\n\n    .forgot-password {\n      margin-bottom: 28px;\n      font-size: 15px;\n      text-align: center;\n\n      .forgot-password-text {\n        color: #6b7280;\n      }\n\n      .forgot-password-link {\n        color: #3b5bdb;\n        margin-inline-start: 5px;\n        text-decoration: none;\n        font-weight: 600;\n        transition: color 0.2s ease;\n\n        &:hover {\n          text-decoration: underline;\n          color: #2845c7;\n        }\n      }\n    }\n\n    .form-title {\n      font-size: 32px;\n      font-weight: 700;\n      color: #1f2937;\n      text-align: center;\n      margin-bottom: 12px;\n      width: 100%;\n      line-height: 1.3;\n    }\n\n    .form-subtitle {\n      display: none;\n    }\n\n    .mode-tabs {\n      display: flex;\n      width: 100%;\n      margin-bottom: 36px;\n      border-bottom: 2px solid #e5e7eb;\n      overflow: hidden;\n      border-radius: 8px 8px 0 0;\n\n      .mode-tab {\n        flex: 1;\n        padding: 18px 0;\n        border: none;\n        background: none;\n        color: #6b7280;\n        font-size: 15px;\n        font-weight: 600;\n        cursor: pointer;\n        position: relative;\n        transition: all 0.3s ease;\n        white-space: nowrap;\n\n        &:hover {\n          color: #374151;\n          background: rgba(59, 91, 219, 0.05);\n        }\n\n        &.active {\n          color: #3b5bdb;\n\n          &::after {\n            content: '';\n            position: absolute;\n            bottom: -2px;\n            left: 0;\n            right: 0;\n            height: 3px;\n            background: #3b5bdb;\n            border-radius: 3px 3px 0 0;\n          }\n        }\n      }\n    }\n\n    .auth-form {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      gap: 28px;\n\n      .input-section {\n        .input-label {\n          display: block;\n          margin-bottom: 10px;\n\n          .label-text {\n            display: inline-flex;\n            align-items: center;\n            font-size: 15px;\n            font-weight: 600;\n            color: #374151;\n            padding: 0;\n          }\n        }\n\n        .input-container {\n          display: flex;\n          border: 2px solid #e5e7eb;\n          border-radius: 12px;\n          overflow: hidden;\n          background: white;\n          position: relative;\n          min-height: 58px;\n          transition: all 0.3s ease;\n\n          &:focus-within {\n            border-color: #3b5bdb;\n            box-shadow: 0 0 0 3px rgba(59, 91, 219, 0.1);\n          }\n\n          .country-code {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            padding: 14px 18px;\n            background: #f9fafb;\n            border-right: 2px solid #e5e7eb;\n            gap: 8px;\n            font-size: 15px;\n            color: #374151;\n            font-weight: 600;\n            min-width: 90px;\n            text-align: center;\n            white-space: nowrap;\n\n            .flag {\n              font-size: 18px;\n              line-height: 1;\n            }\n          }\n\n          .input-field {\n            flex: 1;\n            border: none;\n            padding: 16px 18px;\n            font-size: 16px;\n            color: #1f2937;\n            background: transparent;\n            min-width: 0;\n            font-weight: 500;\n\n            &:focus {\n              outline: none;\n            }\n\n            &::placeholder {\n              color: #9ca3af;\n              font-weight: 400;\n            }\n          }\n\n          .resend-otp-btn {\n            position: absolute;\n            right: 10px;\n            top: 50%;\n            transform: translateY(-50%);\n            background: #3b5bdb;\n            color: white;\n            border: none;\n            padding: 10px 16px;\n            border-radius: 8px;\n            font-size: 13px;\n            font-weight: 700;\n            cursor: pointer;\n            transition: all 0.3s ease;\n            white-space: nowrap;\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n\n            &:hover:not(:disabled) {\n              background: #2845c7;\n              transform: translateY(-50%) scale(1.05);\n            }\n\n            &:disabled {\n              background: #cbd5e1;\n              cursor: not-allowed;\n            }\n          }\n        }\n      }\n\n      .otp-input-section {\n        display: flex;\n        flex-direction: column;\n        gap: 14px;\n\n        .input-label {\n          display: block;\n          margin-bottom: 0;\n\n          .label-text {\n            display: inline-flex;\n            align-items: center;\n            font-size: 15px;\n            font-weight: 600;\n            color: #374151;\n            padding: 0;\n          }\n        }\n\n        .otp-boxes {\n          display: flex;\n          gap: 12px;\n          justify-content: space-between;\n\n          .otp-input {\n            width: 56px;\n            height: 62px;\n            border: 2px solid #e5e7eb;\n            border-radius: 14px;\n            text-align: center;\n            font-size: 22px;\n            font-weight: 700;\n            color: #1f2937;\n            flex: 1;\n            max-width: 70px;\n            transition: all 0.3s ease;\n            background: white;\n\n            &:focus {\n              outline: none;\n              border-color: #3b5bdb;\n              box-shadow: 0 0 0 3px rgba(59, 91, 219, 0.1);\n              transform: scale(1.05);\n            }\n\n            &:not(:placeholder-shown) {\n              border-color: #3b5bdb;\n              background: rgba(59, 91, 219, 0.05);\n            }\n          }\n        }\n      }\n\n      .error-message {\n        background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n        color: #dc2626;\n        padding: 16px 20px;\n        border-radius: 12px;\n        font-size: 15px;\n        border: 2px solid #fecaca;\n        text-align: center;\n        font-weight: 600;\n        animation: shake 0.5s ease-out;\n      }\n\n      @keyframes shake {\n        0%, 100% {\n          transform: translateX(0);\n        }\n        25% {\n          transform: translateX(-10px);\n        }\n        75% {\n          transform: translateX(10px);\n        }\n      }\n\n      .send-otp-btn {\n        width: 100%;\n        background: linear-gradient(135deg, #3b5bdb 0%, #2845c7 100%);\n        color: white;\n        border: none;\n        padding: 18px;\n        border-radius: 14px;\n        font-size: 17px;\n        font-weight: 700;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        min-height: 60px;\n        text-transform: uppercase;\n        letter-spacing: 1px;\n\n        &:hover:not(:disabled) {\n          transform: translateY(-2px);\n          box-shadow: 0 6px 20px rgba(59, 91, 219, 0.4);\n        }\n\n        &:active:not(:disabled) {\n          transform: translateY(0);\n        }\n\n        &:disabled {\n          background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);\n          cursor: not-allowed;\n          box-shadow: none;\n        }\n      }\n\n      .auth-divider {\n        display: flex;\n        align-items: center;\n        color: #9ca3af;\n        font-size: 14px;\n        margin: 8px 0;\n\n        &::before,\n        &::after {\n          content: '';\n          flex: 1;\n          height: 1px;\n          background: #e5e7eb;\n        }\n\n        span {\n          padding: 0 16px;\n        }\n      }\n\n      .social-buttons {\n        display: flex;\n        justify-content: center;\n        gap: 20px;\n        width: 100%;\n\n        .social-btn {\n          flex: 1;\n          height: 52px;\n          border: 2px solid #e5e7eb;\n          border-radius: 12px;\n          background: white;\n          cursor: pointer;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          gap: 10px;\n          transition: all 0.3s ease;\n          position: relative;\n          overflow: hidden;\n          font-size: 16px;\n          font-weight: 600;\n          color: #374151;\n\n          &:hover {\n            background-color: #f9fafb;\n            border-color: #d1d5db;\n            transform: translateY(-2px);\n            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n          }\n\n          &::before {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: -100%;\n            width: 100%;\n            height: 100%;\n            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n            transition: left 0.5s ease;\n          }\n\n          &:hover::before {\n            left: 100%;\n          }\n\n          img {\n            width: 24px;\n            height: 24px;\n            transition: transform 0.3s ease;\n          }\n\n          &:hover img {\n            transform: scale(1.1) rotate(5deg);\n          }\n        }\n      }\n    }\n  }\n\n   .access-denied-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.6);\n    backdrop-filter: blur(8px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 20px;\n\n    .access-denied-modal {\n      background: white;\n      border-radius: 24px;\n      padding: 48px 40px;\n      max-width: 480px;\n      width: 100%;\n      text-align: center;\n      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(0, 0, 0, 0.05);\n      position: relative;\n\n      .access-denied-icon {\n        display: flex;\n        justify-content: center;\n        margin-bottom: 24px;\n\n        svg {\n          animation: modalIconPulse 2s ease-in-out infinite;\n        }\n\n        @keyframes modalIconPulse {\n          0%, 100% {\n            transform: scale(1);\n            opacity: 1;\n          }\n          50% {\n            transform: scale(1.05);\n            opacity: 0.9;\n          }\n        }\n      }\n\n      h2 {\n        font-size: 32px;\n        font-weight: 800;\n        color: #1f2937;\n        margin-bottom: 16px;\n        letter-spacing: -0.5px;\n      }\n\n      .main-message {\n        font-size: 16px;\n        color: #4b5563;\n        font-weight: 500;\n        margin-bottom: 20px;\n        line-height: 1.6;\n      }\n\n      .contact-info {\n        display: flex;\n        justify-content: center;\n        gap: 8px;\n        font-size: 14px;\n        color: #6b7280;\n        background: #f9fafb;\n        padding: 14px 18px;\n        border-radius: 12px;\n        margin-bottom: 28px;\n        font-weight: 500;\n\n        svg {\n          flex-shrink: 0;\n          color: #9ca3af;\n        }\n      }\n\n      .close-modal-btn {\n        width: 100%;\n        background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);\n        color: white;\n        border: none;\n        padding: 16px 28px;\n        border-radius: 14px;\n        font-size: 16px;\n        font-weight: 700;\n        cursor: pointer;\n        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n        letter-spacing: 0.5px;\n\n        &:hover {\n          transform: translateY(-2px);\n          box-shadow: 0 8px 24px rgba(220, 38, 38, 0.4);\n        }\n\n        &:active {\n          transform: translateY(0);\n        }\n      }\n    }\n  }\n\n\n  // Tablet breakpoint (768px - 1024px)\n  @media (max-width: 1024px) {\n    .super-admin-badge {\n      padding: 5px 12px;\n      top: 30px;\n      left: 30px;\n\n      .badge-icon {\n        font-size: 1.8rem;\n      }\n\n      .badge-text {\n        font-size: 0.9rem;\n        letter-spacing: 1.5px;\n      }\n    }\n\n    .form-section {\n      max-width: 520px;\n      border-radius: 24px;\n\n      .auth-form-content {\n        padding: 18px 40px 40px;\n      }\n\n      .form-title {\n        font-size: 28px;\n      }\n    }\n  }\n\n  // CRITICAL: Nest Hub and similar devices (1024x600)\n  @media (max-width: 1024px) and (max-height: 600px) {\n    .super-admin-badge {\n      padding: 10px 24px;\n      top: 20px;\n      left: 20px;\n\n      .badge-icon {\n        font-size: 1.5rem;\n      }\n\n      .badge-text {\n        font-size: 0.8rem;\n        letter-spacing: 1px;\n      }\n    }\n\n    .form-section {\n      max-width: 400px;\n      max-height: 85vh;\n      border-radius: 16px;\n\n      .main-logo-log {\n        padding: 20px 30px 10px;\n\n        .logo-dark-main-login {\n          height: 5vh;\n          min-height: 25px;\n          max-height: 40px;\n        }\n      }\n\n      .auth-form-content {\n        padding: 8px 30px 20px;\n      }\n\n      .form-title {\n        font-size: 20px;\n        margin-bottom: 8px;\n      }\n\n      .forgot-password {\n        margin-bottom: 16px;\n        font-size: 12px;\n      }\n\n      .mode-tabs {\n        margin-bottom: 20px;\n\n        .mode-tab {\n          padding: 10px 0;\n          font-size: 12px;\n        }\n      }\n\n      .auth-form {\n        gap: 16px;\n\n        .input-section {\n          .input-container {\n            min-height: 46px;\n\n            .country-code {\n              padding: 8px 12px;\n              font-size: 12px;\n            }\n\n            .input-field {\n              padding: 10px 12px;\n              font-size: 14px;\n            }\n\n            .resend-otp-btn {\n              font-size: 11px;\n              padding: 6px 10px;\n            }\n          }\n        }\n\n        .otp-input-section {\n          .otp-boxes {\n            .otp-input {\n              width: 40px;\n              height: 46px;\n              font-size: 16px;\n              max-width: 50px;\n            }\n          }\n        }\n\n        .send-otp-btn {\n          padding: 12px;\n          font-size: 14px;\n          min-height: 46px;\n        }\n      }\n    }\n  }\n\n  // Mobile landscape and small tablets (768px)\n  @media (max-width: 850px) {\n    .super-admin-badge {\n      padding: 10px 24px;\n      top: 25px;\n      left: 25px;\n\n      .badge-icon {\n        font-size: 1.6rem;\n      }\n\n      .badge-text {\n        font-size: 0.85rem;\n        letter-spacing: 1px;\n      }\n    }\n\n    .form-section {\n      max-width: 420px;\n      margin: 20px;\n      border-radius: 20px;\n\n      .main-logo-log {\n        padding: 24px 30px 12px;\n\n        .logo-dark-main-login {\n          height: 6vh;\n          min-height: 35px;\n          max-height: 50px;\n        }\n      }\n\n      .auth-form-content {\n        padding: 12px 30px 30px;\n      }\n\n      .form-title {\n        font-size: 22px;\n        margin-bottom: 12px;\n      }\n\n      .mode-tabs {\n        margin-bottom: 24px;\n\n        .mode-tab {\n          padding: 14px 0;\n          font-size: 13px;\n        }\n      }\n\n      .auth-form {\n        gap: 20px;\n\n        .input-section {\n          .input-container {\n            .resend-otp-btn {\n              font-size: 12px;\n              padding: 8px 12px;\n            }\n          }\n        }\n\n        .otp-input-section {\n          .otp-boxes {\n            gap: 8px;\n\n            .otp-input {\n              width: auto;\n              min-width: 42px;\n              max-width: none;\n              flex: 1;\n              height: 50px;\n              font-size: 18px;\n            }\n          }\n        }\n\n        .social-buttons {\n          flex-direction: column;\n          gap: 12px;\n\n          .social-btn {\n            height: 50px;\n          }\n        }\n      }\n    }\n  }\n\n  // Mobile portrait (480px and below)\n  @media (max-width: 480px) {\n    .super-admin-badge {\n      padding: 8px 20px;\n      top: 20px;\n      left: 20px;\n\n      .badge-icon {\n        font-size: 1.4rem;\n      }\n\n      .badge-text {\n        font-size: 0.75rem;\n        letter-spacing: 0.8px;\n      }\n    }\n\n    .bubble {\n      &:nth-child(n+7) {\n        display: none; // Hide some bubbles on small screens\n      }\n    }\n\n    .form-section {\n      max-width: 90%;\n      margin: 15px;\n      border-radius: 18px;\n\n      .main-logo-log {\n        padding: 20px 20px 10px;\n\n        .logo-dark-main-login {\n          height: 5vh;\n          min-height: 32px;\n          max-height: 45px;\n        }\n      }\n\n      .auth-form-content {\n        padding: 10px 20px 25px;\n      }\n\n      .form-title {\n        font-size: 20px;\n        margin-bottom: 8px;\n      }\n\n      .forgot-password {\n        margin-bottom: 16px;\n        font-size: 13px;\n      }\n\n      .mode-tabs {\n        margin-bottom: 20px;\n\n        .mode-tab {\n          padding: 12px 0;\n          font-size: 12px;\n        }\n      }\n\n      .auth-form {\n        gap: 18px;\n\n        .input-section {\n          .input-container {\n            min-height: 50px;\n\n            .country-code {\n              padding: 10px 12px;\n              min-width: 75px;\n              font-size: 13px;\n            }\n\n            .input-field {\n              padding: 12px 14px;\n              font-size: 16px;\n            }\n\n            .resend-otp-btn {\n              font-size: 11px;\n              padding: 7px 11px;\n            }\n          }\n        }\n\n        .otp-input-section {\n          .otp-boxes {\n            gap: 6px;\n\n            .otp-input {\n              height: 48px;\n              font-size: 17px;\n              min-width: 38px;\n            }\n          }\n        }\n\n        .send-otp-btn {\n          padding: 14px;\n          font-size: 15px;\n          min-height: 50px;\n        }\n      }\n    }\n  }\n\n  // Extra small devices (320px and below)\n  @media (max-width: 320px) {\n    .super-admin-badge {\n      padding: 6px 16px;\n      top: 15px;\n      left: 15px;\n\n      .badge-icon {\n        font-size: 1.2rem;\n      }\n\n      .badge-text {\n        font-size: 0.7rem;\n        letter-spacing: 0.5px;\n      }\n    }\n\n    .form-section {\n      max-width: 95%;\n      margin: 10px;\n      border-radius: 16px;\n\n      .main-logo-log {\n        padding: 16px 15px 8px;\n\n        .logo-dark-main-login {\n          height: 4vh;\n          min-height: 28px;\n          max-height: 38px;\n        }\n      }\n\n      .auth-form-content {\n        padding: 8px 15px 20px;\n      }\n\n      .form-title {\n        font-size: 18px;\n        margin-bottom: 6px;\n      }\n\n      .auth-form {\n        gap: 14px;\n\n        .input-section {\n          .input-container {\n            .country-code {\n              padding: 8px 10px;\n              min-width: 68px;\n              font-size: 12px;\n            }\n\n            .input-field {\n              padding: 10px 12px;\n            }\n\n            .resend-otp-btn {\n              font-size: 10px;\n              padding: 6px 9px;\n            }\n          }\n        }\n\n        .otp-input-section {\n          .otp-boxes {\n            gap: 4px;\n\n            .otp-input {\n              min-width: 34px;\n              height: 46px;\n              font-size: 16px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // High DPI displays\n  @media (-webkit-min-device-pixel-ratio: 2),\n  (min-resolution: 192dpi) {\n    .form-section {\n      .main-logo-log {\n        .logo-dark-main-login {\n          image-rendering: -webkit-optimize-contrast;\n        }\n      }\n    }\n  }\n\n  // Dark mode support (if needed)\n  @media (prefers-color-scheme: dark) {\n    // Add dark mode styles if required\n  }\n\n  // Reduced motion preferences\n  @media (prefers-reduced-motion: reduce) {\n    *,\n    *::before,\n    *::after {\n      animation-duration: 0.01ms !important;\n      animation-iteration-count: 1 !important;\n      transition-duration: 0.01ms !important;\n    }\n\n    .bubble {\n      animation: none !important;\n    }\n  }\n\n  // Print styles\n  @media print {\n    .super-admin-badge,\n    .bubble {\n      display: none;\n    }\n\n    .form-section {\n      box-shadow: none;\n      background: white;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
